import { Link } from 'react-router-dom';
import MovieCard from '@/components/base/MovieCard';
import { hotMovies } from '@/mocks/movies';

export default function HotRecommend() {
  return (
    <section className="py-8 px-4 md:px-6 max-w-7xl mx-auto">
      {/* Section header */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
            热门电影推荐
          </h2>
        </div>
        <Link
          to="/category/movie"
          className="flex items-center gap-1 text-foreground-500 hover:text-primary-500 text-sm transition-colors cursor-pointer whitespace-nowrap"
        >
          查看全部
          <i className="ri-arrow-right-line text-xs"></i>
        </Link>
      </div>

      {/* Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
        {hotMovies.map((movie) => (
          <MovieCard key={movie.id} item={movie} />
        ))}
      </div>
    </section>
  );
}